import { isMadPawsStore } from '../../../common/util';
import React from 'react';

const ListCheckIcon = ({ isMobile = false, color = '#238254' }) => {
  const sizeIcon = isMobile ? '18' : '24';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={sizeIcon}
      height={sizeIcon}
      viewBox={`0 0 24 24`}
      fill="none"
    >
      <path
        d="M8.35588 15.2209L5.28905 12.154C4.68736 11.5524 3.70621 11.5711 3.12796 12.1954L2.9811 12.3539C2.43329 12.9453 2.45085 13.8639 3.02086 14.4339L7.29522 18.7083C7.88101 19.2941 8.83076 19.2941 9.41654 18.7083L21.0368 7.08802C21.5688 6.55606 21.5688 5.69358 21.0368 5.16161C20.5173 4.64214 19.6795 4.62817 19.143 5.13004L8.35588 15.2209Z"
        fill={isMadPawsStore() ? '#227979' : color}
      />
    </svg>
  );
};

export default ListCheckIcon;
